import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { AddContact } from './AddContact';
import { DeleteChat } from './DeleteChat';
import { EditContact } from './EditContact';
import ActionsIcon from './../../img/actions-24.png';


export class ActionsMenu extends Component {

    constructor(props) {
        super(props);

        this.state = {
            dropdownOpen: false,
            openAddContact: false,
            openDeleteChat: false,
            openEditContact: false,
        };
        this.toggle = this.toggle.bind(this);
        this.toggleAddContact = this.toggleAddContact.bind(this);
        this.toggleDelete = this.toggleDelete.bind(this);
        this.toggleEditContact = this.toggleEditContact.bind(this);
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    toggleAddContact() {
        this.setState({
            openAddContact: !this.state.openAddContact
        });
    }

    toggleDelete() {
        if (this.props.thread != null) {
            this.setState({
                openDeleteChat: !this.state.openDeleteChat
            });
        }
    }

    toggleEditContact() {
        this.setState({
            openEditContact: !this.state.openEditContact
        });
    }



    render() {
        return (
            <div className="site-header-shown">
                <div id="ddActions" className="dropdown user-menu">
                    <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                        <DropdownToggle
                            tag="a"
                            className="dropdown-toggle dropdown-toggle-txt"
                            onClick={this.toggle}
                            data-toggle="dropdown"
                            aria-expanded={this.state.dropdownOpen}
                        >
                            <div className="div_contact_actionsIcon">
                                <div className="divMenuIcon">
                                    <img src={ActionsIcon} alt="" />
                                </div>
                            </div>
                        </DropdownToggle>
                        <DropdownMenu >
                            {/*<DropdownItem>*/}
                            {/*    <a onClick={this.toggleAddContact}>Start Message</a>*/}
                            {/*</DropdownItem>*/}
                            <DropdownItem disabled={this.props.thread == null ? true : false}>
                                <a onClick={this.props.thread != null ? this.toggleDelete : ''} className={this.props.thread == null ? 'disabled' : ''} >Delete History</a>
                            </DropdownItem>
                            {/*<DropdownItem>*/}
                            {/*    <a onClick={this.toggleEditContact}>Edit Contact</a>*/}
                            {/*</DropdownItem>*/}
                        </DropdownMenu>
                    </Dropdown>
                </div>
                <AddContact isOpen={this.state.openAddContact} addContact={this.props.addContact} toggle={this.toggleAddContact} />
                <DeleteChat thread={this.props.thread} isOpen={this.state.openDeleteChat} deleteChat={this.props.deleteChat} toggle={this.toggleDelete} />
                <EditContact thread={this.props.thread} isOpen={this.state.openEditContact} memberDetail={this.props.memberDetail} editContact={this.props.editContact} toggle={this.toggleEditContact} />
            </div>

        )
    }

}

